import { isValidPath, handleUnauthorized } from './token'
import {
  incrementLoadingCount,
  decrementLoadingCount,
  handleForbidden,
  handleNotFound,
  handleTooManyRequests,
  handleServerError,
  handleUnAuthorized,
  handleValidationError,
  handleAnyErrors,
} from './ajax'

// Setep axios headers
export function initHeaders() {
  window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  window.axios.defaults.headers.common.Accept = 'application/json'

  /**
   * Next we will register the CSRF Token as a common header with Axios so that
   * all outgoing HTTP requests automatically have it attached. This is just
   * a simple convenience so we don't have to attach every token manually.
   */

  const csrfToken = document.head.querySelector('meta[name="csrf-token"]')

  if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content
  } else {
    throw new Error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
  }
}

// Setup axios interceptor
export function initInterceptors() {
  // apiモジュールであれば以下はスキップ
  if (window.location.pathname.indexOf('/api') !== -1) return

  // 認証失敗したらログアウトする
  if (isValidPath) {
    window.axios.interceptors.response.use(
      res => res,
      err => handleUnauthorized(err),
    )
  }

  // 読み込み中表示
  window.axios.interceptors.request.use(
    config => incrementLoadingCount(config),
    err => Promise.reject(err),
  )
  window.axios.interceptors.response.use(
    res => decrementLoadingCount(res),
    err => decrementLoadingCount(Promise.reject(err)),
  )
  window.axios.interceptors.response.use(
    res => res,
    err => handleForbidden(err),
  )

  window.axios.interceptors.response.use(
    res => res,
    err => handleNotFound(err),
  )

  window.axios.interceptors.response.use(
    res => res,
    err => handleTooManyRequests(err),
  )

  window.axios.interceptors.response.use(
    res => res,
    err => handleServerError(err),
  )

  window.axios.interceptors.response.use(
    res => res,
    err => handleUnAuthorized(err),
  )

  window.axios.interceptors.response.use(
    res => res,
    err => handleValidationError(err),
  )

  window.axios.interceptors.response.use(
    res => res,
    err => handleAnyErrors(err),
  )
}
